import { Components } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { FlexRow } from "../../../Common/Styles";
import { ContentProps } from "./Content";

const PreviewLayout = ({
  onDelete,
  onEdit,
  children,
  width,
}: ContentProps.PreviewLayoutProps) => {
  return (
    <PreviewContainer $width={width}>
      <PreviewHeading>
        <Components.Label kind="Fill" text="Preview" color="Primary" />
        <FlexRow $gapInPx={8}>
          <Components.IconButton
            kind="Tertiary"
            iconType={"Trash2"}
            disabled={false}
            size="Small"
            onClick={onDelete}
          />
          <Components.IconButton
            kind="Tertiary"
            iconType={"Edit"}
            disabled={false}
            size="Small"
            onClick={onEdit}
          />
        </FlexRow>
      </PreviewHeading>
      <div>{children}</div>
    </PreviewContainer>
  );
};

export default PreviewLayout;

export const PreviewHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

export const PreviewContainer = styled.div<{
  $width?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-primary-subtle"].value};
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
  width: ${({ $width }) => ($width ? $width : "fit-content")};
  transition: gap 0.3s ease;
`;
